import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ROLE_PATH_PREFIXES = new Set(["admin", "hod", "teacher", "student", "superadmin"]);

export function normalizeRoleSlug(rawRole) {
  if (!rawRole) return "";
  let slug = rawRole;
  if (typeof rawRole === "object" && rawRole !== null) {
    slug = rawRole.slug ?? rawRole.name ?? "";
  }
  const s = String(slug).trim().toLowerCase().replace(/[_\s]+/g, "");
  if (s === "institute") return "admin";
  if (s === "superadmin" || s === "superadministrator") return "superadmin";
  return s;
}

/**
 * Route prefix for role-scoped pages. Matches App.js and Sidebar:
 * super admin in "Manage Institute" context uses /admin/*, not /superadmin/*.
 */
export function useEffectiveRolePath() {
  const { pathname } = useLocation();
  const user = useSelector((state) => state.auth?.user);
  const { isInInstituteContext } = useSelector((state) => state.instituteContext || {});

  const firstSegment =
    pathname.split("/").find((s) => s.length > 0)?.toLowerCase() ?? "";
  const pathRoleHint = ROLE_PATH_PREFIXES.has(firstSegment) ? firstSegment : null;

  const rawRole = user?.role ?? pathRoleHint ?? "admin";
  const role = normalizeRoleSlug(rawRole) || "admin";
  const basePath = `/${role}`;
  const rolePath =
    role === "superadmin" && isInInstituteContext ? "/admin" : basePath;

  return { rolePath, role, isInInstituteContext };
}

export default useEffectiveRolePath;
